import { createContext, useEffect, useState } from 'react';
import { APIGet } from '../API';

// @ts-ignore
const WhistlesContext = createContext();

export const useWhistles = () => {
	const [whistlesData, setWhistlesData] = useState(undefined)
	const [whistles, setWhistles] = useState(undefined)
	const [whistlesTab, setWhistlesTab] = useState(undefined)
	const [nmbWhistles, setNmbWhistles] = useState(undefined)
	const [noWhistlesLink, setNoWhistlesLink] = useState(undefined)

	const getWhistles = (me) => {
		setWhistles(undefined)
		const resource = 'whistles';
		APIGet(resource, { company_id: me.company_id }).then((res) => {
			if (res.data["user_whistles"] && res.data["user_whistles"].length) {
				setNmbWhistles(res.data["user_whistles"].length)
			} else {
				setNmbWhistles(0)
			}
			setWhistlesData(res.data);
		})
	};


	useEffect(() => {
		if (whistlesData) {
			if ("link" in whistlesData){
				setNoWhistlesLink(whistlesData.link)
			}
			const { user_whistles, company_whistles } = whistlesData;
			if (user_whistles.length > 0 && company_whistles.length > 0) {
				whistlesData.company_whistles = company_whistles.filter(whistle => !user_whistles.find(el => el.id === whistle.id))
				if (whistlesData.company_whistles.length > 0) {
					if(!whistlesTab)
						setWhistlesTab('user_whistles');
				}else{
					setWhistlesTab(undefined)
				}
				setWhistles(whistlesData['user_whistles'])
			} else {
				setWhistlesTab(undefined)
				setWhistles([...user_whistles, ...company_whistles])
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [whistlesData])

	const handleSetWhistlesTab = (type) => {
		setWhistlesTab(type);
		setWhistles(whistlesData[type])
	}

	const getCategories = () => {
		if (whistles === undefined)
			return []

		return Array.from(
			new Set([...whistles].reduce((cats, curr) => {
				if (curr["categories"]) {
					const newCategories = cats.concat(curr["categories"])
					return newCategories
				}
				return []
			}, []))
		)
	}

	return {
		whistles,
		noWhistlesLink,
		whistlesTab,
		setWhistlesTab: handleSetWhistlesTab,
		nmbWhistles,
		getWhistles,
		getCategories
	}
}

export default WhistlesContext
